module.exports = __webpack_public_path__ + "53b97f8dd0e3c588beb2d0ec71c2885a.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/pin_new_24.svg
// module id = 1363
// module chunks = 74